export default class NumbersDecimals {

  constructor() {
    this.restrict = 'EA';
    this.require = 'ngModel';
  }

  link(scope, element, attrs, ngModel) {

    function fromUser(text) {
        if (text) {
            var ex = new RegExp(/^\d+(?:\.\d{0,2})?$/);
            var transformedInput = text;
            if(!ex.test(text)){
                transformedInput = text.substring(0,text.length - 1);
            }

            if (transformedInput !== text) {
                ngModel.$setViewValue(transformedInput);
                ngModel.$render();
            }
            return transformedInput;
        }
        return undefined;
    }            
    ngModel.$parsers.push(fromUser);
  }

  static create() {
    return new NumbersDecimals();
  }
}


// WEBPACK FOOTER //
// ./app/js/directives/numbersDecimals.js